/*eslint-disable*/
import React from "react";
import {
  Flex,
  Link,
  List,
  ListItem,
  Text,
  useColorModeValue,
} from "@chakra-ui/react";

export default function Footer() {
  let textColor = useColorModeValue("gray.400", "white");
  let linkColor = useColorModeValue({ base: "gray.400", lg: "white" }, "white");
  return (
    <Flex
      zIndex='3'
      flexDirection={{ base: "column", lg: "row" }}
      alignItems='center'
      justifyContent='flex-start'
      px={{ base: "30px", md: "0px" }}
      pb='30px'
      w={{ base: "100%", lg: "50%" }}
      flexWrap='wrap'
    >
      {/* Left Side */}
      <Text
        color={textColor}
        textAlign={{ base: "center", lg: "start" }}
        mb={{ base: "10px", lg: "0px" }}
        fontWeight='500'
        w={{ base: "100%", lg: "auto" }}
        mr={{ lg: "20px" }}
        fontSize={14}
      >
        © {new Date().getFullYear()} RHI Journals, All rights reserved.
      </Text>

      {/* Right Side */}
      <Text
        color={textColor}
        textAlign={{ base: "center", lg: "start" }}
        fontWeight='500'
        w={{ base: "100%", lg: "auto" }}
        fontSize={14}
      >
        Designed and Developed by <a href="https://bioinformatic.rhc.ac.ir/" target="_blank" style={{ color: '#f80c3e', fontWeight: 'bolder' }}>Bioinformatic Department</a>, Rajaie Institute
      </Text>
    </Flex>
  );
}
